import React from "react";
import Input from "../../../../Components/Common/Input";

const RoleForm = ({ onChange, handleSubmit, errors, formData }) => {
  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-2">
      <Input
        label="Role Name"
        name="roleName"
        required
        placeholder="Enter role name"
        onChange={onChange}
        error={errors.roleName}
        value={formData.roleName}
      />
      <Input
        label="Description"
        name="description"
        placeholder="Enter description"
        onChange={onChange}
        error={errors.description}
        value={formData.description}
      />
    </form>
  );
};

export default RoleForm;
